import { css } from "@emotion/css";
import { useMemo, useRef } from "react";
import { useEffect, useState } from "react";
import { convertSecondToTime } from "utils/common";
import DotLayout from "./dot-layout";
import { isMobile } from "react-device-detect";

interface Props {
	time: any;
	startTime: any;
	isSecond?: boolean;
	onFinish?: () => void;
	result: number[] | null;
	gameType: number;
}
function TimeCount(props: Props) {
	const { time, startTime, onFinish, isSecond, result, gameType } = props;
	const idInterValRef = useRef<any>(null);
	const [timeCount, setTimeCount] = useState(isSecond ? "00" : "00:00:00");

	const handleFinish = () => {
		if (onFinish) onFinish();
		setTimeCount("MỞ BÁT");
	};

	useEffect(() => {
		if (result) {
			setTimeCount(time);
		}
	}, [result]);

	useEffect(() => {
		const countDownFrom = new Date(startTime).getTime() + (time + 1) * 1000;
		idInterValRef.current = setInterval(() => {
			const distance = countDownFrom - new Date().getTime();
			const timeFormat = convertSecondToTime(Math.floor(distance / 1000), true);
			if (Math.floor(distance / 1000) <= 0) {
				handleFinish();
				// setTimeCount(isSecond ? '00' : '00:00:00');
				clearInterval(idInterValRef.current);
				return;
			}

			setTimeCount(timeFormat);
		}, 1000);
		return () => {
			clearInterval(idInterValRef.current);
		};
	}, [time, startTime]);

	return (
		<div className={`${styles.wrapCount} ${isMobile ? "mobile" : ""}`}>
			{result ? <DotLayout gameType={gameType} dotList={result} /> : <span className={timeCount === "MỞ BÁT" ? styles.textOrange : styles.textGreen}>{timeCount}</span>}
		</div>
	);
}

const styles = {
	wrapCount: css`
		background: #29374c;
		padding: 4px 12px;
		border-radius: 8px;
		min-width: 40px;
		font-weight: 600;
		height: 28px;
		display: flex;
		align-items: center;
		justify-content: center;
		&.mobile {
			height: 24px;
			span {
				font-size: 14px;
			}
		}
	`,
	textGreen: css`
		color: #3cff00;
	`,
	textRed: css`
		color: #db0000;
	`,
	textOrange: css`
		color: #fbae3d;
	`,
};

export default TimeCount;
